import React, { Component } from 'react';
import styled from 'react-emotion';
import firebase from 'firebase';

import { TextField } from 'material-ui';
import { GradientButton } from './GradientButton';
import screenshot from '../assets/images/screenshot.png';

import Typography from 'material-ui/Typography/Typography';
const emailRegex = /.+@.+\..{2,}/;

const Container = styled('div')`
  padding-top: 2em;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

const TextContainer = styled('div')`
  max-width: 80%;
  margin: 0 auto;
  text-align: center;
`

const InputRow = styled('div')`
  display: inline;
`;

const SpacedInput = styled(TextField)`
  margin: 1em;
`;

const SpacedButton = styled(GradientButton)`
  margin: 1em;
`;

const ScreenshotContainer = styled('div')`
  width: 600px;
  max-width: 100%;
  height: 525px;
  overflow: hidden;
`;

const Screenshot = styled('img')`
  width: 100%;
`;

export class Download extends Component {
  constructor() {
    super();
    this.state = {
      email: '',
      emailInvalid: false,
      emailSubmitted: false,
      alreadySubmitted: false,
    }
  }

  emailFieldChange = event => {
    const value = event.target.value;
    if (value.match(emailRegex)){
      this.setState({
        email: value,
        emailInvalid: false
      });
    } else {
      this.setState({
        emailInvalid: true
      });
    }
  }

  updateEmail(exists, email, key) {
    if (exists) return Promise.resolve({
      emailSubmitted: true,
      alreadySubmitted: !!exists,
    });

    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref('/emails')
        .update({ [key]: email })
        .then(() => resolve({ emailSubmitted: true }))
        .catch(reject);
    });
  }

  submitEmail = () => {
    const key = this.state.email.replace(/[@.]/g, '');

    firebase
      .database()
      .ref(`/emails/${key}`)
      .once('value')
      .then(snapshot => this.updateEmail(snapshot.val(), this.state.email, key))
      .then(state => this.setState({...state}))
      .catch(console.error);
  }

  render() {
    const allSet = 'thanks for signing up!';
    const alreadySignedUp = 'you\'ve already signed up!'
    return (
      <Container id="download">
        <TextContainer>
          <Typography type='display3' gutterBottom>
            Coming Soon!
          </Typography>
          <Typography type='body1' gutterBottom>
            Sign up for email updates! We promise to only email you when something really exciting happens <span role="img" aria-label="Smiley Face">😊</span>
          </Typography>
        </TextContainer>
        {this.state.emailSubmitted
          ?
            <Typography type='body1'>
              You're all set, {this.state.alreadySubmitted ? alreadySignedUp : allSet}
            </Typography>
          : <InputRow>
            <SpacedInput
              id="email"
              label="Email"
              type="email"
              error={this.state.emailInvalid}
              onChange={this.emailFieldChange}
            />
            <SpacedButton
              onClick={this.submitEmail}
              disabled={!this.state.email || this.state.emailInvalid}>
              Sign Up!
            </SpacedButton>
          </InputRow>
        }
        <ScreenshotContainer>
          <Screenshot src={screenshot} alt="Argo App Screenshot" />
        </ScreenshotContainer>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Download.jsx